import React, { Fragment, Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import 'date-fns';
import '../../styles.css';
import { numberFormat } from '../../utils/common_utils';
import { EnhancedTableToolbar, EnhancedTableHead } from '../../utils/common_page_with_table';
import { Global, inlineStyles } from '../../utils/global';
import SnackerBar from '../../utils/SnackerBar';
import Button from '@material-ui/core/Button';
import { Link, Grid, MenuItem } from '@material-ui/core';
import { Column, Row } from 'simple-flexbox';

const reportTitle = "Banks Transactions";
const url = 'cash/banktransactions.php';

export default class BankTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 1,
            banks: [],
            branches: [],
            selectedBank: 0,
            selectedBranch: 0,
            addlFormData: [{ name: 'selectedID', value: props.parentComponent.state.selectedID },{name:'selectedBranchID', value: 0},{name:'selectedBankID', value: 0}],
            deleteDialogOpen: false,
            editDialogOpen: false,
            dense: false,
            id: 0,
            isLoading: true,
            isDataLoading: false,
            isDialogDataLoading: false,
            notification: '',
            objName: '',
            order: 'asc',
            orderBy: 'dateOfTransaction',
            page: 0,
            pageTotal: 0,
            rows: [],
            rowsPerPage: 100,
            searchFor: '',
            selected: [],
            snackBarMsg: '',
            snackBarMsgType: '',
            snackBarOpen: false,
            showClearSearchBtn: false,
            url: props.parentComponent.state.API_HOST + url,
            schema: [],
        };
    }
    openSnackBar = (snackBarMsg, snackBarMsgType, snackBarOpen) => {
        this.setState({ snackBarMsg: snackBarMsg, snackBarMsgType: snackBarMsgType, snackBarOpen: snackBarOpen });
    }
    setComponentState = (sState, vState) => {
        this.setState({ [sState]: vState });
    }
    handleTextfieldChange = (name) => event => {
        Global.setStateValue(this, name, event.target.value);
        return;
    };
    setAddlStateValue = (name, v) => {       
        var addlFormData =  this.state.addlFormData;
        var values = { ...this.state.addlFormData };
        console.log('values',values);
        addlFormData.find((o, i) => {
          if (o.name === name) {
            values[i].value = v;
            return true;
          }
        });
        this.setState({ values });
      }
    handleSelectionChange = (name) => event => {
        if (name==='branch') {
            this.setState({'selectedBranch':event.target.value});
            this.setAddlStateValue('selectedBranchID', event.target.value);
        } else {
            this.setState({'selectedBank':event.target.value});
            this.setAddlStateValue('selectedBankID', event.target.value);
        }        
        return;
    };
    submitFilter = () => {
        Global.loadList(this,{});
    }
    handleRequestSort = (event, property) => {
        var isDesc = this.state.order === 'desc';
        var order = isDesc || this.state.orderBy !== property ? 'asc' : 'desc';
        var values = {
            order: order,
            orderBy: property,
        };
        this.setComponentState('order', order);
        this.setComponentState('orderBy', property);
        Global.loadList(this, values);
    }
    setSearch = (e) => {
        var v = e.target.value;
        this.setState({ searchFor: v });
        if (v) {
            this.setComponentState('showClearSearchBtn', true);
        } else {
            this.setComponentState('showClearSearchBtn', false);
        }
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            var newSelecteds = this.state.rows.map(n => n.name);
            this.setComponentState('selected', newSelecteds);
            return;
        }
        this.setComponentState('selected', []);
    }

    handleChangePage = (event, newPage) => {
        this.setComponentState('page', newPage);
        Global.loadList(this, { page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setComponentState('rowsPerPage', event.target.value);
        Global.loadList(this, { rowsPerPage: event.target.value });
    }

    handleChangeDense = (event) => {
        this.setComponentState('dense', event.target.checked);
    }

    handleDialogClose = () => {
        this.setDeleteDialogOpen(false);
    }
    confirmDeleteRow(id, name) {
        this.setState({ id: id });
        this.setState({ objName: name });
        this.setDeleteDialogOpen(true);
    }
    confirmDeletion = (id) => {
        Global.deleteRow(this, id);
    }
    setDeleteDialogOpen = (v) => {
        this.setState({ deleteDialogOpen: v });
        if (!v) {
            Global.loadList(this, {});
        }
    }
    setEditDialogOpen = (v) => {
        this.setState({ editDialogOpen: v });
    }
    editRow = (id) => {
        Global.getOneRow(this, id);
        this.setEditDialogOpen(true);
    }
    addNew = () => {
        var values = { ...this.state.schema };
        values.id = 0;
        this.setState({ values });
        this.setEditDialogOpen(true);
    }
    toolBarItems = () => {        
        return (
            <Column flexGrow={1}>
                <Row vertical='center' horizontal='right'>
                    <Column flexGrow={1} horizontal='center'>
                        <TextField
                            select
                            variant="outlined"
                            margin="dense"
                            name="selectedBranchID"
                            label=""
                            style={{minWidth:'125px', marginRight:'10px'}}
                            value={this.state.selectedBranch}
                            onChange={this.handleSelectionChange('branch')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled={this.state.isDataLoading}
                        >
                            {
                                this.state.branches.length > 0 && this.state.branches.map((itemrow, itemindex) => {
                                    return (
                                        <MenuItem key={itemindex} value={itemrow.key}>{itemrow.value}</MenuItem>
                                    )
                                })
                            }

                        </TextField>
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <TextField
                            select
                            variant="outlined"
                            margin="dense"
                            name="selectedBankID"
                            label=""
                            style={{minWidth:'125px'}}
                            value={this.state.selectedBank}
                            onChange={this.handleSelectionChange('bank')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled={this.state.isDataLoading}
                        >
                            {
                                this.state.banks.length > 0 && this.state.banks.map((itemrow, itemindex) => {
                                    return (
                                        <MenuItem key={itemindex} value={itemrow.key}>{itemrow.value}</MenuItem>
                                    )
                                })
                            }

                        </TextField>
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <Button onClick={this.submitFilter} style={{ marginLeft: 5, padding: "0 5px" }} color="primary" variant='contained' size="small">
                            Submit
                            </Button>
                    </Column>
                </Row>
            </Column>
        )
    }

    componentDidMount() {
        if (this.state.isLoading && !this.state.isDataLoading) {
            var postData = [];
            postData.push({ name: 'selectedID', value: this.props.parentComponent.state.selectedID });
            Global.getSchema(this, false, null, postData);
        }
    }
    render() {
        var headRows = [];
        var formValues = this.state.schema;
        formValues.forEach((row) => {
            headRows.push({ id: row.name, label: row.label, numeric: row.numeric, showInList: row.showInList });
        });

        headRows.push({ id: 'action', label: 'Actions', numeric: false, showInList: true });
        var repTitle = reportTitle;
        return (
            <Fragment>
                <Paper style={inlineStyles.paper}>
                    {
                        this.state.notification &&
                        <Typography paragraph color="error" align="center" style={{ 'padding': 20 }}>
                            {this.state.notification}
                        </Typography>
                    }
                    {
                        this.state.isDataLoading &&
                        <Fragment>
                            <div style={{ 'padding': 50, 'textAlign': 'center' }}>
                                <CircularProgress />
                            </div>
                        </Fragment>
                    }
                    {!this.state.isDataLoading &&
                        <Fragment>
                            <EnhancedTableToolbar
                                numSelected={this.state.selected ? this.state.selected.length : 0}
                                toolbarTitle={repTitle}
                                showSearchBox={true}
                                toolBarItems={this.toolBarItems}
                                actionButtons=""
                                t={this}
                                Global={Global}
                            />
                            <div style={inlineStyles.tableWrapper}>
                                <Table
                                    style={inlineStyles.table}
                                    aria-labelledby="tableTitle"
                                    size={this.state.dense ? 'medium' : 'small'}
                                >
                                    <EnhancedTableHead
                                        numSelected={this.state.selected ? this.state.selected.length : 0}
                                        order={this.state.order}
                                        orderBy={this.state.orderBy}
                                        onSelectAllClick={this.handleSelectAllClick}
                                        onRequestSort={this.handleRequestSort}
                                        headRows={headRows}
                                    />
                                    <TableBody>
                                        {this.state.rows && this.state.rows.length > 0 && this.state.rows.map((row, index) => {
                                            const labelId = `table-row-${index}`;
                                            return (
                                                <TableRow
                                                    hover
                                                    key={index}
                                                >
                                                    <TableCell className="listRowNum" id={labelId} scope="row" padding="none" align="center">
                                                        {index + 1 + (this.state.page * this.state.rowsPerPage)}
                                                    </TableCell>
                                                    {formValues.filter(col => col.showInList).map((col, colindex) => {
                                                        var rowVal = row[col.name];
                                                        if (col.type === 'select') {
                                                            var menuItem = col.items.find(colItems => colItems.key == rowVal);
                                                            if (typeof menuItem === 'object' && menuItem.hasOwnProperty('value')) {
                                                                rowVal = menuItem.value;
                                                            } else {
                                                                rowVal = '';
                                                            }
                                                        }

                                                        var colval = rowVal;
                                                        colval = col.numeric ? numberFormat(colval) : colval;
                                                        return (
                                                            <TableCell key={colindex} align={col.numeric ? 'right' : (col.align ? col.align : 'left')}>
                                                                {colval}
                                                            </TableCell>
                                                        );
                                                    })
                                                    }

                                                </TableRow>
                                            );
                                        })
                                        }
                                        {this.state.rows && !this.state.rows.length &&
                                            <TableRow><TableCell align="center" colSpan={8}>{"No result"}</TableCell></TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </div>
                            {!this.state.isDataLoading && this.state.pageTotal > 1 &&
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    component="div"
                                    count={this.state.count}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            }
                        </Fragment>
                    }
                </Paper>
                <FormControlLabel
                    control={<Switch checked={this.state.dense} onChange={this.handleChangeDense} />}
                    label="Show bigger cells"
                />

                <SnackerBar msg={this.state.snackBarMsg} msgType={this.state.snackBarMsgType} opened={this.state.snackBarOpen} t={this} />
            </Fragment>
        );
    }
}